/*
* 取每个菜单图标
*
* */
import { querySql } from '@/api/Api'
import { DeviceHandler } from '@/deviceHelper'
import { Toast } from 'vant'

function getMenus() {
  return [
    {
      id: '001', text: '货品上架', name: 'GoodsShelf', target: './inboundPutaway/InboundPutaway', icon: 'shangjia'
    },
    {
      id: '003', text: '出库作业', name: 'PickingHall', target: './picking/PickingHall', icon: 'chukuzuoye'
    },

    // {
    //   id: '004',
    //   text: '打包拆分',
    //   name: 'PackSplit',
    //   target: './packSplit/PackSplit',
    //   icon: 'dabaochaifen'
    // },
    {
      id: '005', text: '拼箱合并', name: 'PackMerge', target: './combinePackage/CombinePackage', icon: 'pinxiang'
    },
    {
      id: '006', text: '出库复核', name: 'ReviewHall', target: './review/ReviewHall', icon: 'fuhe'
    },
    {
      id: '007', text: '移库开票', name: 'MakeTransferOrder', target: './moveMakeInvoice/MoveMakeInvoice', icon: 'feedback'
    },
    {
      id: '008', text: '容器入库', name: 'ContainerInbound', target: './containerInbound/ContainerInbound', icon: 'rukuqueren'
    },
    {
      id: '009', text: '容器出库', name: 'ContainerOutbound', target: './container/ContainerOutbound', icon: 'rongqichuku1'
    },
    {
      id: '010', text: '入库收货', name: 'Receipt', target: './receipt/Receipt', icon: 'jianhuoyichang'
    },
    {
      id: '011', text: '收货质检', name: 'Inspect', target: './inspect/Inspect', icon: 'jianhuoyichang'
    },
    {
      id: '011', text: '打包复核', name: 'ContainerReview', target: './packing/ContainerReview', icon: 'jianhuoyichang'
    },
    {
      id: '012', text: '拣货单复核', name: 'PickingOrderReview', target: './packing/PickingOrderReview', icon: 'jianhuoyichang'
    },// {
    //   id: '015',
    //   text: '入库装箱',
    //   name: 'InboundPack',
    //   target: './inboundEnchase/InboundEnchase',
    //   icon: 'rukuzhuangxiang'
    // },
    // {
    //   id: '016',
    //   text: '出库换箱',
    //   name: 'OutboundExchange',
    //   target: './outboundBoxChange/OutboundBoxChange',
    //   icon: 'huanxiang'
    // },
    {
      id: '025', text: '小库房拣选', name: 'SpecialHall', target: './special/SpecialHall', icon: 'lengku'
    }, {
      id: '026', text: '补货上架', name: 'ReplenishmentShelf', target: './inbount/ReplenishmentShelf', icon: 'buhuoshangjia'
    }
    // {
    //   id: '029',
    //   text: '入库码盘',
    //   name: 'PalletizeBind',
    //   target: './inbound/PalletizeBind',
    //   icon: 'rukumapan'
    // },
    // {
    //   id: '030',
    //   text: '设备拣货',
    //   name: 'DevicePicking',
    //   target: './devicePicking/DevicePicking',
    //   icon: 'shebeijianhuo'
    // },
    // {
    //   id: '031',
    //   text: '滑槽标签补打',
    //   name: 'biaoqianbuda',
    //   target: './printBarcode/PrintBarcode',
    //   icon: 'cancel'
    // },
    // {
    //   id: '032',
    //   text: '打印机列表',
    //   name: 'PrinterList',
    //   target: './PrinterList',
    //   icon: 'enlarge'
    // },
    // {
    //   id: '033',
    //   text: '货位调整',
    //   name: 'LocationMoveOrder2',
    //   target: './movebound/LocationMoveOrder',
    //   icon: 'replay'
    // },
    // {
    //   id: '034',
    //   text: '中药拣货',
    //   name: 'TPSPick',
    //   target: './TPSPick/TPSPick',
    //   icon: 'zhongyaojianhuo'
    // },
    // {
    //   id: '036',
    //   text: '库存盘查',
    //   name: 'ItemExamine',
    //   target: './itemExamine/ItemExamine',
    //   icon: 'pandian'
    // },
  ]
}

function getUser() {//取用户对象
  return JSON.parse(localStorage.getItem('user'))
}

function setUser(user) {//存用户对象
  localStorage.setItem('user', JSON.stringify(user))
}

function getUserId() {//取用户id
  return localStorage.getItem('userId')
}

function setUserId(userId) {//存用户id
  localStorage.setItem('userId', userId)
}

function getEnterpriseId() {//取企业id
  return localStorage.getItem('enterpriseId')
}

function setEnterpriseId(enterpriseId) {//存企业id
  localStorage.setItem('enterpriseId', enterpriseId)
}

function getWarehouseId() {//取物流中心id
  return localStorage.getItem('warehouseId')
}

function setWarehouseId(warehouseId) {//存物流中心id
  localStorage.setItem('warehouseId', warehouseId)
}

function getType() {//取登录类型
  return localStorage.getItem('type')
}

function setType(type) {//存登录类型
  localStorage.setItem('type', type)
}

function getIp() {
  return localStorage.getItem('ip')
}

function setIp(ip) {
  localStorage.setItem('ip', ip)
}

/*
 *  查询各包装监管码数
*   @actualQuantity 数量
*   @barCode  监管码
*   @middleFactor 中包装数
*   @largeFactor 大包装数
* */
function getSupervisionBarcode(actualQuantity, barCode = {}, middleFactor, largeFactor) {
  const item = {}
  if (largeFactor) {
    item.small = barCode.small//小包装监管码集合
    item.middle = barCode.middle//中包装监管码集合
    item.large = barCode.large//大包装监管码集合
    item.smallSweptNumber = barCode.middle.length * middleFactor + barCode.small.length + barCode.large.length * largeFactor//小包装已扫数量
    item.middleSweptNumber = Math.floor(item.smallSweptNumber / middleFactor)//中包装已扫数量,并向下取整
    item.largeSweptNumber = Math.floor(item.smallSweptNumber / largeFactor)//大包装已扫数量,并向下取整
    item.smallScannedNumber = actualQuantity / 1//小包装应扫数量
    item.middleScannedNumber = Math.floor(actualQuantity / middleFactor)//中包装应扫数量,并向下取整
    item.largeScannedNumber = Math.floor(actualQuantity / largeFactor)//大包装应扫数量,并向下取整
  } else {
    item.small = barCode.small//小包装监管码集合
    item.middle = barCode.middle//中包装监管码集合
    item.smallSweptNumber = barCode.middle.length * middleFactor + barCode.small.length//小包装已扫数量
    item.middleSweptNumber = Math.floor(item.smallSweptNumber / middleFactor)//中包装已扫数量,并向下取整
    item.smallScannedNumber = actualQuantity / 1//小包装应扫数量
    item.middleScannedNumber = Math.floor(actualQuantity / middleFactor)//应扫数量,并向下取整
  }
  console.log(item)
  return item


}

/*
*    移除对象中为null的属性，并可选择是否移除空数组。
*    @param obj 要处理的对象。
*    @param removeEmptyArray 是否移除空数组，默认为 false.
*    @returns 返回处理后的对象。
* */

function removeNullValues(obj, removeEmptyArray) {
  if (!obj) return {}
  for (const key in obj) {
    if (obj[key] === null || (removeEmptyArray && Array.isArray(obj[key]) && !obj[key].length)) {
      delete obj[key]
    } else if (typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
      obj[key] = removeNullValues(obj[key], removeEmptyArray)
    }
  }
  return obj
}

/**
 * 获取指定日期：
 * @param {number} days 指定日期的前后N天
 * @param {string} date 指定日期
 * @param {string} format 指定格式
 * @returns {string} 返回时间
 */
function getSpecDate(days, date, format) {
  days = days || 0
  let currDate = date ? new Date(date) : new Date()
  let specTime = currDate.setDate(currDate.getDate() + days)
  const formatDate = (date, format) => {
    const padStart = (value, length, char) => {
      value = value + ''
      return value.padStart(length, char)
    }
    if (!date) return '--'
    let _date = date
    format = format || 'YYYY-MM-DD'
    let splitArr = format.split(/(YYYY|MM|DD|hh|mm|ss)+/)

    if (typeof date !== 'object') {
      _date = new Date(date)
    }

    return splitArr.map(item => {
      if (item === 'YYYY') {
        return _date.getFullYear()
      }

      if (item === 'MM') {
        return padStart(_date.getMonth() + 1, 2, 0)
      }

      if (item === 'DD') {
        return padStart(_date.getDate(), 2, 0)
      }

      if (item === 'hh') {
        return padStart(_date.getHours(), 2, 0)
      }
      if (item === 'mm') {
        return padStart(_date.getMinutes(), 2, 0)
      }
      if (item === 'ss') {
        return padStart(_date.getSeconds(), 2, 0)
      }
      return item
    }).join('')
  }
  return formatDate(specTime, format)
}

//返回 2015-03-19 格式
function FormatDate(datetime) {
  if (datetime == null) {
    return null
  }
  var y = datetime.getFullYear()
  var m = datetime.getMonth() + 1
  m = m < 10 ? '0' + m : m
  var d = datetime.getDate()
  d = d < 10 ? '0' + d : d
  return y + '-' + m + '-' + d
}

//返回 2009-06-12 17:18:05 格式
function FormatDateTime(datetime) {
  if (datetime == null) {
    return ''
  }
  var year = datetime.getFullYear()
  var month = datetime.getMonth() + 1 //js从0开始取
  var date = datetime.getDate()
  var hour = datetime.getHours()
  var minutes = datetime.getMinutes()
  var second = datetime.getSeconds()
  if (month < 10) {
    month = '0' + month
  }
  if (date < 10) {
    date = '0' + date
  }
  if (hour < 10) {
    hour = '0' + hour
  }
  if (minutes < 10) {
    minutes = '0' + minutes
  }
  if (second < 10) {
    second = '0' + second
  }
  var time = year + '-' + month + '-' + date + ' ' + hour + ':' + minutes + ':' + second //2009-06-12 17:18:05
  return time
}

//返回  17:18 格式
function FormatTime(datetime) {
  if (datetime == null) {
    return null
  }
  var hour = datetime.getHours()
  var minutes = datetime.getMinutes()
  if (hour < 10) {
    hour = '0' + hour
  }
  if (minutes < 10) {
    minutes = '0' + minutes
  }
  var time = hour + ':' + minutes //17:18
  return time
}

function getOutBoundCaseData(sqlQuery) {
  querySql(sqlQuery).then(res => {
    if (res.success && res.result.length > 0) {
      // let commits = []
      const printList = []
      res.result.map((item, i) => {
        let Dt = [
          {
            pxh: item.拼箱号 ? item.拼箱号 : '',//箱号
            gjx: item.共几箱 ? item.共几箱 : '',//共几箱
            xh: item.序号 ? item.序号 : '',//共几箱
            sfsssx: item.是否上输送线 ? item.是否上输送线 : '',//是否上输送线
            cktm: item.出库条码 ? item.出库条码 : '',//出库条码
            khmc: item.客户名称 ? item.客户名称 : '',//客户名称
            khbh: item.客户编号 ? item.客户编号 : '',//客户编号
            dysj: item.打印时间 ? item.打印时间 : '',//打印时间
            sfys: item.是否易碎 ? item.是否易碎 : '',//是否已碎
            lc: item.楼层 ? item.楼层 : '',//楼层
            ddh: item.订单号 ? item.订单号 : '',//订单号
            ysfs: item.运输方式 ? item.运输方式 : '',//运输方式
            jhy: item.拣货员 ? item.拣货员 : '',//存储位
            ccw: item.存储位 ? item.存储位 : '',//存储位
            jhw: item.集货位 ? item.集货位 : '',//集货区
            dby: item.打包员 ? item.打包员 : '',//复核员
            dbw: item.打包位 ? item.打包位 : '', //打包位
            itemname: item.商品名称 ? item.商品名称 : '',//商品名称
            lotno: item.批号 ? item.批号 : '',//批号
            qty: item.数量 ? item.数量 : '',//数量
            remqty: '',//
            uom: item.包装单位 ? item.包装单位 : '',//包装单位
            mave: item.波次号 ? item.波次号 : '', //波次号
            factor: item.包装数 ? item.包装数 : '',//包装数
            sendno: item.播种位 ? item.播种位 : '',//播种位
            itemno: item.商品编码 ? item.商品编码 : '',//商品编码
            spec: item.规格 ? item.规格 : '', //规格
            sfsj: item.是否视觉 ? item.是否视觉 : '',//是否视觉
            xuh: i + 1 + '/' + res.result.length               //序列号
          }
        ]
        if (Dt.length > 0) {
          let print = {
            'PLAN_CODE': '080038',
            'WH_ID': '560456239167959042',
            'DATA': Dt
          }
          printList.push(print)
        }
      })
      if (printList.length > 0) {
        DeviceHandler.printWithDataList(printList, (item, res) => {
          if (res.hasOwnProperty('msg')) {

          }
        })
      }

    } else {
      Toast('无打印数据')
    }
  })


}

function getOutBoundEachData(sqlQuery) {
  querySql(sqlQuery).then(res => {
    if (res.success && res.result.length > 0) {
      const printList = []
      res.result.map((item, i) => {
        let Dt = [
          {
            ddh: item.订单号 ? item.订单号 : '',//订单号
            mave: item.波次号 ? item.波次号 : '',//波次号
            khbh: item.客户编号 ? item.客户编号 : '',//客户编号
            khmc: item.客户名称 ? item.客户名称 : '',//客户名称
            xh: item.序号 ? item.序号 : '',  //序号
            gjx: item.共几箱 ? item.共几箱 : '',//共几箱
            remqty: item.余量 ? item.余量 : '',//余量
            pxh: item.拼箱号 ? item.拼箱号 : '',//箱号
            jhw: item.集货位 ? item.集货位 : '',//集货区
            dbw: item.打包位 ? item.打包位 : '', //打包位
            lc: item.楼层 ? item.楼层 : '',//楼层
            ysfs: item.运输方式 ? item.运输方式 : '',//运输方式
            dysj: item.打印时间 ? item.打印时间 : '',//打印时间
            cktm: item.出库条码 ? item.出库条码 : '',//出库条码
            sfwx: item.sfwx,  //是否尾箱
            sy: i + 1 + '/' + res.result.length
          }
        ]
        if (Dt.length > 0) {
          printList.push(
            {
              'PLAN_CODE': '090005',
              'WH_ID': '560456239167959042',
              'DATA': Dt
            }
          )
        }
      })
      DeviceHandler.printWithDataList(printList, (item, res) => {
        if (res.hasOwnProperty('msg')) {
        }
      })
    } else {
      Toast('无打印数据')
    }
  })
}

function getOutBoundReplenishData(sqlQuery) {
  querySql(sqlQuery).then(res => {
    if (res.success && res.result.length > 0) {
      const printList = []
      res.result.map((item, i) => {
        let Dt = [
          {
            brhw: item.补入货位 ? item.补入货位 : '',//补入货位
            bchw: item.补出货位 ? item.补出货位 : '',//补出货位
            spmc: item.商品名称 ? item.商品名称 : '',//商品名称
            sfsssx: item.是否上输送线 ? item.是否上输送线 : '',//是否上输送线
            gg: item.规格 ? item.规格 : '',//规格
            bzs: item.包装数 ? item.包装数 : '',//包装数
            sccj: item.生产厂家 ? item.生产厂家 : '',//生产厂家
            bhtm: item.补货条码 ? item.补货条码 : '',//补货条码
            js: item.件数 ? item.件数 : '',//件数
            ddh: item.订单号 ? item.订单号 : '',//订单号
            ddlx: item.订单类型 ? item.订单类型 : '',//订单类型
            ph: item.批号 ? item.批号 : '',//批号
            scrq: item.生产日期 ? Ext.util.Format.date(item.生产日期, 'Y-m-d') : '',//生产日期
            yxrq: item.有效日期 ? Ext.util.Format.date(item.有效日期, 'Y-m-d') : '',//有效日期
            dysj: item.打印时间 ? item.打印时间 : '',//打印时间
            qty: item.数量 ? item.数量 : '',//数量
            itemcode: item.商品编码 ? item.商品编码 : '',//商品编码
            wave: item.波次号 ? item.波次号 : '',//波次号
            xh: i + 1 + '/' + res.result.lenght//序号
          }
        ]
        if (Dt.length > 0) {
          let print = {
            'PLAN_CODE': '080018',
            'WH_ID': '560456239167959042',
            'DATA': Dt
          }
          printList.push(print)
        }
      })
      DeviceHandler.printWithDataList(printList, (item, res) => {
        if (res.hasOwnProperty('msg')) {

        }
      })

    } else {
      Toast('无打印数据')
    }
  })
}

export {
  getMenus,
  getUser,
  setUser,
  getUserId,
  setUserId,
  getEnterpriseId,
  setEnterpriseId,
  getWarehouseId,
  setWarehouseId,
  getType,
  setType,
  getIp,
  setIp,
  getSupervisionBarcode,
  removeNullValues,
  getSpecDate,
  FormatDate,
  FormatDateTime,
  FormatTime,
  getOutBoundCaseData,
  getOutBoundEachData,
  getOutBoundReplenishData
}
